import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Home, Zap, Shield, Database, Settings, HardDrive, Bot, Download, Layers, ShieldCheck, Cloud } from 'lucide-react';
import { useAuth } from '../context/AuthContext';

const Sidebar = () => {
  const location = useLocation();
  const { user, isAdmin } = useAuth();

  const navItems = [
    { path: '/', label: 'Home', icon: Home },
    { path: '/performance', label: 'Performance', icon: Zap },
    { path: '/security', label: 'Security', icon: Shield },
    { path: '/high-availability', label: 'High Availability', icon: Database },
    { path: '/backup-recovery', label: 'Backup & Recovery', icon: HardDrive },
    { path: '/automation', label: 'Automation', icon: Bot },
    { path: '/installation', label: 'Installation', icon: Download },
    { path: '/architecture', label: 'Architecture & Config', icon: Layers },
    { path: '/azure-sql', label: 'Azure SQL', icon: Cloud },
    { path: '/maintenance', label: 'Miscellaneous', icon: ShieldCheck },
  ];

  if (isAdmin) {
    navItems.push({ path: '/admin', label: 'Admin Panel', icon: Settings });
  } else if (user?.role === 'author') {
    navItems.push({ path: '/admin', label: 'Author Panel', icon: Settings });
  }

  return (
    <aside className="sidebar">
      <nav className="sidebar-nav">
        {navItems.map(item => {
          const Icon = item.icon;
          const isActive = location.pathname === item.path;
          
          return (
            <Link
              key={item.path}
              to={item.path}
              className={`nav-item ${isActive ? 'active' : ''}`}
            >
              <Icon className="nav-item-icon" size={20} />
              {item.label}
            </Link>
          );
        })}
      </nav>
    </aside>
  );
};

export default Sidebar;